import { AuditServicePayload } from '@openeducation/oe-it-shared-types';

import { AuditServiceDao } from '../dao/audit-service.dao';
import type { Environment } from '../interfaces';

export abstract class AuditServiceService {
  static async postAuditService(
    env: Environment,
    payload: AuditServicePayload
  ) {
    return !env
      ? Promise.reject(new Error('environment is missing'))
      : await AuditServiceDao.postAuditService(env, payload);
  }
}
